import Box, { BoxProps as IBoxProps } from './Box';
export default Box;
export type BoxProps = IBoxProps;
